<template>
	<v-content>
		<v-progress-linear
			class="progress-bar"
			:indeterminate="showIndeterminate"
			v-if="showIndeterminate">
		</v-progress-linear>
		<v-container fluid pa-0>
			<app-header
				:quantity-notifications="quantityNotifications"
				:mini="mini"
				@open-notifications-event="openNotificationsModal"
				@open-sidebar="openSiderbar"
			/>
			<app-sidebar
				:is-visible="isVisible"
				:mini="mini"
				@active-route="getRoutes"
				@click-list="clickListItem"
				@click-btn-toggle="openSiderbar"
			/>
			<section class="section-margin">
				<slot></slot>
			</section>
			<action-sidebar
				:width="action.width"
				v-model="action.open"
				:code-action="action.code"
				:title="action.title"
				:active="action.active"
				:img-src="action.imgSrc"
				:is-loading="loading"
				:header-color="action.color"
			></action-sidebar>
			<div
				v-if="!mini"
				class="overlay-menu"
				@click="clickListItem"></div>
		</v-container>
	</v-content>
</template>

<script>
import { mapActions } from 'vuex';
import actionSidebar from '@/components/shared/action-sidebar';
import appHeader from '@/components/shared/app-header';
import appSidebar from '@/components/shared/app-sidebar';

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
}

function notifications() {
	const allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach((productNot) => {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach((saleNot) => {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function routeHandler(to, from) {
	const fromRoute = {
		name: from.name,
		params: from.params,
		query: from.query,
		meta: from.meta,
	};
	const toRoute = {
		name: to.name,
		params: to.params,
		query: to.query,
		meta: to.meta,
	};
	const onlyRoute = toRoute.name === 'company-new' && fromRoute.name !== 'companies';
	this.$setBreadCrumbs({ fromRoute, toRoute, onlyRoute });
}

function openSiderbar() {
	this.mini = !this.mini;
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

function clickListItem() {
	if (this.$route.name === 'journal') {
		this.mini = true;
	} else {
		this.mini = false;
	}
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468,
		},
		isVisible: true,
		loading: false,
		routes: [],
		mini: false,
	};
}

export default {
	name: 'layout-admin',
	components: {
		actionSidebar,
		appHeader,
		appSidebar,
	},
	computed: {
		showIndeterminate,
		notifications,
		quantityNotifications,
	},
	data,
	methods: {
		...mapActions('route', {
			$setBreadCrumbs: 'SET_BREAD_CRUMBS',
		}),
		closeNotificationsModal,
		getRoutes,
		openNotificationsModal,
		routeHandler,
		toggleSidebar,
		openSiderbar,
		clickListItem,
	},
	watch: {
		$route: routeHandler,
	},
};
</script>



// WEBPACK FOOTER //
// src/layouts/layout-admin.vue